import {
  FREEMIUM_PRIORITY_LEVEL,
  FULL_PRIORITY_LEVEL,
  LIGHT_PRIORITY_LEVEL,
  PRO_PRIORITY_LEVEL,
} from '@/utils/plans/plansConstants'

export default {
  [`${FREEMIUM_PRIORITY_LEVEL}`]: {
    allowedRoutes: [
      '/account/activate',
      '/catalog',
      '/farms',
      '/login',
      '/my_farm',
      '/notes',
      '/payment',
      '/plans',
      '/plot',
      '/profile',
    ],
    upsellRoutes: [
      '/comparacao',
      '/cultivares',
      '/execucao',
      '/integrations',
      '/performance',
      '/programas',
      '/reports/programa',
      '/reports/season-report',
      '/sowings',
      '/users',
    ],
    disabledRoutes: [],
  },
  [`${LIGHT_PRIORITY_LEVEL}`]: {
    allowedRoutes: [
      '/account/activate',
      '/catalog',
      '/farms',
      '/login',
      '/my_farm',
      '/notes',
      '/payment',
      '/plans',
      '/plot',
      '/profile',
    ],
    upsellRoutes: [
      '/comparacao',
      '/cultivares',
      '/execucao',
      '/integrations',
      '/performance',
      '/programas',
      '/reports/programa',
      '/reports/season-report',
      '/sowings',
      '/users',
    ],
    disabledRoutes: [],
  },
  [`${PRO_PRIORITY_LEVEL}`]: {
    allowedRoutes: [
      '/account/activate',
      '/catalog',
      '/comparacao',
      '/cultivares',
      '/farms',
      '/login',
      '/my_farm',
      '/notes',
      '/payment',
      '/plans',
      '/plot',
      '/profile',
      '/programas',
    ],
    upsellRoutes: [
      '/execucao',
      '/integrations',
      '/performance',
      '/reports/programa',
      '/reports/season-report',
      '/sowings',
      '/users',
    ],
    disabledRoutes: [],
  },
  [`${FULL_PRIORITY_LEVEL}`]: {
    allowedRoutes: [
      '/account/activate',
      '/catalog',
      '/comparacao',
      '/cultivares',
      '/execucao',
      '/farms',
      '/integrations',
      '/login',
      '/my_farm',
      '/notes',
      '/performance',
      '/plot',
      '/profile',
      '/programas',
      '/reports/programa',
      '/reports/season-report',
      '/sowings',
      '/users',
    ],
    upsellRoutes: [],
    disabledRoutes: ['/payment', '/plans'],
  },
}
